module.exports = __webpack_public_path__ + "img/i.6c19b4a3.jpg";